export default __webpack_public_path__ + "static/media/rocket_anim_18.a9266f47.png";